<template>
    <div name="pharmacy-card" class="card">
        
        <div class="row2" style="margin-top: 16px; height: 48px;">
            <span class="name">{{ info.name }}</span>
            <div class="share-button" @click="share">
                <img style="margin-right: 4px; width: 22px;" src="../../../assets/share3.png" />
                공유
            </div>
        </div>
        <div class="row3" style="margin-top: 6px;">
            <span class="label" style="margin-right: 8px;">주소</span>
            <span class="address-phone">{{ info.address }}</span>
        </div>
        <div class="row3" style="margin-top: 8px;">
            <span class="label" style="margin-right: 8px;">연락처</span>
            <span class="address-phone">{{ info.phone_Number }}</span>
        </div>

        <div class="row" style="justify-content: flex-start;margin-top: 16px;">
            <div @click="viewMedicines(info)" :class="isPreSelectedPharmacy(info.index) ? 'action-button' : 'action-button-active'" >
                <img style="margin-right: 4px;" src="../../../assets/icon.png" />
                <span v-if="!isPreSelectedPharmacy(info.index)">{{ hasBaqsimi ? '취급 약품 보기' : '취급 인슐린 보기' }}</span>
                <span v-else>{{ hasBaqsimi ? '약품 다시 보기' : '인슐린 다시 보기' }}</span>
            </div>
            <span v-if="hasBaqsimi" class="baqsimi-badge">바크시미취급</span>
        </div>
        <div class="button-bar" style="margin-top: 16px;">
            <div v-if="isList" class="action-button2" @click="viewMaps(info)">
                <span>지도</span>
            </div>
            <div class="action-button2" @click="guidanceRoute(info.name, info.longitude, info.latitude)" >
                <span>길찾기</span>
            </div>
            <div class="action-button2" v-if="isMobile" @click="tel(info.phone_Number)">
                <span>전화</span>
            </div>
        </div>
        <div class="medicine-list" style="margin-top: 20px;" v-if="isViewMedicineList">
            <div class="row2" style="margin-bottom: 20px;">
                <span class="list-label">{{ hasBaqsimi ? '취급 약품 품목' : '취급 인슐린 품목' }}</span>
                <span class="list-info"><span style="color: #184FA1;">*</span>품목, 재고 사전 확인 필요</span>
        
            </div>
            <span class="empty-medicine-text" v-if="info.medicines === null || info.medicines === '' || info.medicines === '확인필요'">
                약국에 직접 문의
            </span>
            <span class="list-data" v-for="(medicine, index) in medicines" :key="index">{{ medicine }}</span>
        </div>
    </div>
</template>

<script>
import Constant from '@/constant';
import {mapState} from 'vuex';
import Medicine from '@/utilities/medicine';
export default {
    name: 'pharmacyCard',
    props: ['info', 'isList'],
    computed: {
        ...mapState(['checkPharmacyList']),
        hasBaqsimi: function()
        {
            return Medicine.hasBaqsimi(this.info.medicines);
        }
    },
    data: function()
    {
        return {
            isViewMedicineList: false,
            medicines: [],
            isMobile: false
        }
    },
    mounted: function()
    {
        if(!this.isPC())
        {
            this.isMobile = true;
        }
        else
        {
            this.isMobile = false;
        }
    },  
    methods: {
        isPC:function () {
            const userAgent = navigator.userAgent.toLowerCase();
            const isMobile = /iphone|ipod|android|blackberry|windows phone|opera mini|iemobile|mobile/i.test(userAgent);
            return !isMobile;
        },
        copy: function(address)
        {
            navigator.clipboard.writeText(address)
            .then(() => {
                console.log("클립보드에 복사되었습니다:", address);
                alert("클립보드에 복사되었습니다: " + address)
            })
            .catch(err => {
                console.error("복사 실패:", err);
            });
        },
        viewMedicines: function(info)
        {

            this.$store.commit(Constant.SET_CHECKED_PHARMACY, {pharmacyId: info.index})

            // this.$router.push({path: `/detail/${info.index}?back=${this.isList ? 'list' : 'map'}`})
            this.$emit('viewDetail', info)
            // if(data !== null  || data !== '')
            // {
            //     this.medicines = [];
            //     const dd = data.split(", ");
            //     dd.forEach(element => {
            //         if(element !== '확인필요')
            //         {
            //             this.medicines.push(element)
            //         }
                   
            //     });
            // }

            // this.isViewMedicineList = !this.isViewMedicineList;

        },
        viewMaps: function(info)
        {
            this.$emit('viewMaps', info)
        },
        guidanceRoute: function(name, longitude, latitude)
        {
            window.open(`https://m.map.naver.com/route.nhn?menu=route&ename=${name}&ex=${longitude}&ey=${latitude}&pathType=0&showMap=true`, '_blank')
        },
        tel: function(phone)
        {
            window.location.href = `tel:${phone}`;
        },
        share: function()
        {
            this.$emit('share', this.info)
        },
        isPreSelectedPharmacy: function(index)
        {
            return this.checkPharmacyList.includes(index);
        }
    }
}
</script>

<style scoped>
    .card {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        padding: 20px 16px;
        box-sizing: border-box;
        background: #FFF;
    }

    .name {
        color: #1E1E1E;
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        width: 207px;
    }
    .address-phone {
        /* 카드 가로 길이에 맞춰 남은 폭을 모두 사용 */
        flex: 1;
        min-width: 0;
        color: #6B7684;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 111.111% */
        word-break: keep-all;
        overflow-wrap: anywhere;
    }
    .copy-button {
        color: var(--point-color1, #008DEF);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 111.111% */
        letter-spacing: 0.54px;
        text-decoration-line: underline;
        text-decoration-style: solid;
        text-decoration-skip-ink: none;
        text-decoration-thickness: auto;
        text-underline-offset: auto;
        text-underline-position: from-font;
        cursor: pointer;
    }
    .action-button {
        display: flex;
        padding: 8px 16px;
        justify-content: center;
        align-items: center;    
        border-radius: 6px;
        border: 1px solid var(--gray-40-button-stroke, #D1D6DB);
        color: var(--Gray-100, #1E1E1E);
        text-align: center;
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 18px; /* 100% */
        cursor: pointer;
        margin-right: 8px;
    }

    .baqsimi-badge {
        margin-left: auto;
        flex-shrink: 0;
        padding: 4px 10px;
        border-radius: 100px;
        background: #FFD43B;
        color: #1E1E1E;
        font-family: Pretendard;
        font-size: 13px;
        font-style: normal;
        font-weight: 600;
        line-height: 16px;
    }

    .action-button-active {
        display: flex;
        padding: 8px 16px;
        justify-content: center;
        align-items: center;    
        border-radius: 6px;
        background: #184FA1;
        color: var(--Gray-00, #FFF);
        text-align: center;
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 18px; /* 100% */
        cursor: pointer;
        margin-right: 8px;
    }

    .medicine-list {
        display: flex;
        width: 100%;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        max-height: 371px;
        overflow-y: auto;
        background: var(--Gray-20, #F3F5F8);
        padding: 20px 16px;
        box-sizing: border-box;
    }

    .list-label {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 111.111% */
    }

    .list-info {
        color: var(--Gray-60, #6B7684);
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        letter-spacing: -0.36px;
    }
    .list-data {
        display: flex;
        height: 24px;
        padding: 0 4px;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;
        border-radius: 6px;
        background: var(--Gray-00, #FFF);
        color: #184FA1;
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin-bottom: 8px;
    }

    .empty-medicine {
        color: var(--Gray-60, #6B7684);
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;     
        font-weight: 400;
        line-height: normal;
        display: flex;
        height: 24px;
        padding: 0 4px;
        justify-content: center;
        align-items: center;
    }

    .row {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        overflow-x: auto;
        overflow-y: hidden;
        white-space: nowrap;
    }
    .row2 {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .empty-medicine-text {
        display: flex;
        height: 24px;
        padding: 0 4px;
        justify-content: center;
        align-items: center;
        color: var(--Gray-60, #6B7684);
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        border-radius: 6px;
        background: var(--gray-30-stroke, #E8EAEE);
    }
    .share-button {
        box-sizing: border-box;
        height: 32px;
        border-radius: 100px;
        background: var(--Gray-20, #F3F5F8);
        display: flex;
        justify-content: center;
        align-items: center;
        border: none;
        color: var(--Gray-100, #1E1E1E);
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: 18px; /* 100% */
        cursor: pointer;
        width: 74px;
    }
    .label {
        color: var(--Gray-50, #A3AAB6);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 111.111% */
        width: 47px;
        flex-shrink: 0;
    }
    .row3 {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        width: 100%;
    }
    .button-bar {
        width: 100%;
        display: flex;
        gap: 8px;

    }
    .action-button2 {
        width: 100%;
        height: 44px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #1E1E1E;
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: 22px; /* 122.222% */
        border-radius: 6px;
        background: var(--Gray-sub-color1, #F3F5F8);
    }
</style>


// WEBPACK FOOTER //
// src/components/molecules/maps/PharmacyCard.vue